var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PanelMenu } from "primereact/panelmenu";
/**
 * @typedef {object} BeoPanelMenuProps
 * @property {React.Ref<PanelMenu>} [ref] - A ref object or function to access the underlying PanelMenu instance.
 * @property {any} [model] - The array of menu items to display (specific structure depends on the underlying PanelMenu).
 * @property {boolean} [multiple] - Whether multiple menu items can be open at the same time.
 * @property {string} [className] - CSS class name for the component's root element.
 *
 */
/**
 * A wrapper component around a base PanelMenu component, designed for use within the BEO ecosystem.
 * * This component simply forwards all props and a ref to the underlying PanelMenu implementation.
 * It's useful for providing a consistent, branded, or configuration-locked version of a common UI component.
 * @author rajeev.k
 * @param {BeoPanelMenuProps} props
 * @returns {JSX.Element}
 */
var BeoPanelMenu = function (_a) {
    var ref = _a.ref, props = __rest(_a, ["ref"]);
    return _jsx(PanelMenu, __assign({ ref: ref }, props));
};
export default BeoPanelMenu;
